import React, { Component } from 'react'
import CodeConfirm from '../CodeConfirm/index.jsx'
import FormatDataInput from './formatDataInput.jsx'
import FormatDataSelect from './formatDataSelect.jsx'

export default class Profile extends Component {
    constructor(props) {
        super(props)

        this.state = {
            profileDataParams: {},
        }

        this.translation = JSON.parse(localStorage.translation)[
            localStorage.language
        ]
    }

    componentDidMount() {
        this.changeProfileDataParams()
    }

    componentDidUpdate(prevProps, prevState) {
        this.changeProfileDataParams(prevProps)
    }

    changeProfileDataParams = prevProps => {
        if (
            prevProps === undefined ||
            prevProps.profileData !== this.props.profileData
        ) {
            let profileDataParams = {}
            this.props.profileData.forEach((item, i) => {
                if (
                    profileDataParams[item.key] === undefined &&
                    item.key !== '2fa_type'
                ) {
                    profileDataParams[item.key] = item.value
                }
            })
            this.setState({
                profileDataParams,
            })
        }
    }

    render() {
        let { profileDataParams } = this.state
        let formatData = this.props.profileData.map((item, i) => {
            if (
                profileDataParams[item.key] === undefined ||
                item.key === '2fa_type'
            ) {
                return null
            } else if (item.key === '2fa_available_types') {
                return <div key={i}>{this.switchFormatData(item)}</div>
            } else {
                return (
                    <div
                        key={i}
                        className={
                            !item.readOnly
                                ? 'profile__data-item'
                                : 'profile__data-item readOnly'
                        }
                    >
                        <p>{this.translation[item.title]}</p>
                        {this.switchFormatData(item)}
                    </div>
                )
            }
        })

        return (
            <div className="profile__data-list">
                {formatData}
                {Object.keys(profileDataParams).length !== 0 &&
                    this.props.id !== 'tfa' && (
                        <CodeConfirm
                            id={this.props.id}
                            profileData={this.props.profileData}
                            profileDataParams={this.state.profileDataParams}
                            dataProtection={this.props.dataProtection}
                            tfaCodeRequestRequired={
                                this.props.tfaCodeRequestRequired
                            }
                            tfaType={this.props.tfaType}
                        />
                    )}
            </div>
        )
    }

    switchFormatData = item => {
        let { profileDataParams } = this.state
        let {
            tfaType,
            getStatus,
            phoneVerificationRequired,
            dataProtection,
        } = this.props

        switch (item.type) {
            case 'input':
                return (
                    <FormatDataInput
                        item={item}
                        profileDataParams={profileDataParams}
                        phoneVerificationRequired={phoneVerificationRequired}
                        dataProtection={dataProtection}
                        profileDataChange={this.profileDataChange}
                    />
                )
                break
            case 'select':
                return (
                    <FormatDataSelect
                        item={item}
                        profileDataParams={profileDataParams}
                        tfaType={tfaType}
                        dataProtection={dataProtection}
                        getStatus={getStatus}
                        profileDataChange={this.profileDataChange}
                    />
                )
                break
            default:
                return (
                    <input
                        value={profileDataParams[item.key]}
                        readOnly={true}
                        placeholder={this.translation[item.title]}
                    />
                )
        }
    }

    profileDataChange = (item, event) => {
        let profileDataParams = Object.assign({}, this.state.profileDataParams)
        profileDataParams[item.key] = event.target.value
        this.setState({
            profileDataParams,
        })
    }
}
